pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginBadgeView = require 'app/scripts/views/plugin/plugin-badge-view'
t = require('teacup')
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

template = t.renderable ({ callback, url, title, text } = {}) ->
  t.h3 '.card-detail-item-header', ->
    t.text title

  if url && pluginValidators.isValidUrlForIframe(url)
    t.a '.card-detail-badge.plugin-card-detail-badge.is-clickable.js-badge',
      { href: url, rel: 'noreferrer nofollow noopener', target: url, title: text }, ->
        t.text text
  else if callback
    t.a '.card-detail-badge.plugin-card-detail-badge.is-clickable.js-badge',
      { href: '#', title: text }, ->
        t.text text
  else
    t.span '.card-detail-badge.plugin-card-detail-badge.static-detail-badge.js-badge',
      { title: text }, ->
        t.text text

module.exports = class PluginCardDetailBadgeView extends PluginBadgeView
  tagName: 'div'
  className: 'card-detail-item'

  renderBadge: (badge) ->
    @$el.html(template(badge))
    @$('.js-badge')

  events:
    'click .js-badge': (e) ->
      if !@pluginBadge.callback? && !@pluginBadge.url?
        return
      Util.stopPropagation(e)
      { idPlugin } = @pluginBadge
      trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-detail-badge', idPlugin)
      sendPluginUIEvent(idPlugin, {
        action: 'clicked'
        actionSubject: 'badge'
        source: 'cardDetailScreen'
        actionSubjectId: 'cardDetailBadge'
        objectType: 'powerUp'
        objectId: idPlugin
      })
      if @pluginBadge.callback?
        e.preventDefault()
        @pluginBadge.callback
          el: e.currentTarget
        .done()
